import ClassNames from 'classnames'

import { getThemeImageUrl } from '../../utils'
import { config } from '../../../components/Init/Init'

import classes from './styles/notificationMessage.module.scss'

export const NotificationMessage = ({ message, options }) => {
  const componentClassName = ClassNames(classes.notificationMessage)

  const iconSrc = ClassNames({
    [classes.timeIcon]: config.notificationConfigs.icons.time === options.icon,
    [classes.checkmarkEncircled]: config.notificationConfigs.icons.checkmarkEncircled === options.icon
  })

  return (
    <div className={componentClassName}>
      {options.icon && (
        <img alt={options.icon} src={getThemeImageUrl(iconSrc)} className={classes.notificationMessage_icon} />
      )}
      <div>{message}</div>
    </div>
  )
}
